var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCode = function SvgCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.196 2.02a1 1 0 0 1 .785 1.176l-2 10a1 1 0 1 1-1.962-.392l2-10a1 1 0 0 1 1.177-.785Zm3.53 9.68a.999.999 0 0 1-1.428 0 .998.998 0 0 1 0-1.403L13.919 8l-2.631-2.297a.998.998 0 0 1 .327-1.625.999.999 0 0 1 1.1.222l2.637 2.447.21.195a1.498 1.498 0 0 1 0 2.116L12.726 11.7ZM3.274 4.3a.999.999 0 0 1 1.428 0 .998.998 0 0 1 0 1.403L2.081 8l2.631 2.297a.999.999 0 0 1-.327 1.625.999.999 0 0 1-1.1-.222L.647 9.253l-.21-.195a1.498 1.498 0 0 1 0-2.116L3.274 4.3Z",
    clipRule: "evenodd"
  })));
};
export default SvgCode;